var hotelInfoTabs = vueIfExists({
	el: '#hotel-info-tabs',
	data: {
		activeTab: 'amenities',
		content: {},
		loaded: false,
		hotelTabObserver: null,
		showReviews: true,
		sharedState: store.state,
		loadedEvent: new Event('hotelInfoLoaded', { bubbles: true })
	},
	mounted: function() {
		this.showReviews = !win.isMobile || this.sharedState.siteLink == 'hotelReviews';
		var siteLinkTab = ['hotelReviews', 'hotelPolicies', 'hotelAmenities'].indexOf(this.sharedState.siteLink) != -1;

		if (!siteLinkTab && "IntersectionObserver" in window) {
		    this.hotelTabObserver = new IntersectionObserver(function(caller) { 
		    	return function(entries, observer) {
     				if (entries[0].isIntersecting) {
						caller.getHotelInfo();
						this.unobserve(caller.$el);
			        }
			    };}(this),
			    {
			    	rootMargin: '200px'
			    }
			).observe(this.$el);
		} else {
			this.getHotelInfo(); // do not lazyload if IntersectionObserver is not supported
		}
		var hash = document.location.hash.replace('#', '');
		if (siteLinkTab || ['info', 'amenities', 'policies'].indexOf(hash) != -1 && win.hotelHeaderMenu) {
			if (this.sharedState.siteLink == 'hotelReviews') {
				this.activeTab = 'reviews';
			} else if (this.sharedState.siteLink == 'hotelPolicies') {
				this.activeTab = 'policies';
			} else if (this.sharedState.siteLink == 'hotelAmenities') {
				this.activeTab = 'amenities';
			} else {
				this.activeTab = hash;
			}
			Vue.nextTick(function() {
				$d.scrollto({ distance: win.isMobile ? 0 : -gE('header-hotel-fixed').offsetHeight || -65, toElement: gE('hotel-info-tabs'), duration: 0});
			});
		}
	},
	methods: {
		hideTabs: function() {
			this.$el.classList.add('hidden');
		},
		getHotelInfo: function() {
			win.$ajax.getJson({
				url: win.jsonUrl.hotelInfo,
				params: { intHotelId: this.sharedState.hotel.id },
				scope: this,
				success: function(json) {
					this.content = json;
					// winning AB test hiding reviews on mobile
					if (!this.showReviews) {
						this.content.reviews = [];
					}
				    win.hotelHeaderMenu.hasReviews = this.content.reviews.length > 0;
				    win.hotelHeaderMenuFixed.hasReviews = this.content.reviews.length > 0;
				    if (this.content.reviews.length === 0 && this.activeTab == 'reviews') {
				    	this.activeTab = 'amenities';
				    }
				    this.loaded = true;
	                document.dispatchEvent(this.loadedEvent);
				},
				failed: function() {
					this.hideTabs();
				}
			});
		}
	}
});